import script from "./SfxOverlayNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxOverlayNotifications.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import TouchHold from 'quasar/src/directives/touch-hold/TouchHold.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QScrollArea,QCardSection,QTabPanels,QTabPanel});qInstall(script, 'directives', {TouchHold});
